import { render, staticRenderFns } from "./view-article.vue?vue&type=template&id=4bae9794&scoped=true"
import script from "./view-article.vue?vue&type=script&lang=js"
export * from "./view-article.vue?vue&type=script&lang=js"
import style0 from "./view-article.vue?vue&type=style&index=0&id=4bae9794&prod&lang=css"
import style1 from "./view-article.vue?vue&type=style&index=1&id=4bae9794&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bae9794",
  null
  
)

export default component.exports